#import "@/components/common/StoryPreviewFragment.gql"
#import "@/components/common/LinkFragment.gql"

fragment StoryTeaserBlackFragment on storyTeaserBlack_Entry {
  typeHandle
  heading
  cta {
    ...LinkFragment
  }
  stories {
    ...StoryPreviewFragment
  }
}
